import { render, staticRenderFns } from "./AppFooterMenu.vue?vue&type=template&id=72e8ad7b&scoped=true&lang=pug&"
import script from "./AppFooterMenu.vue?vue&type=script&lang=js&"
export * from "./AppFooterMenu.vue?vue&type=script&lang=js&"
import style0 from "./AppFooterMenu.vue?vue&type=style&index=0&id=72e8ad7b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e8ad7b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
